// 接入主应用后重新翻译的跳转地址
export function baseHost() {
    let baseUrl;
    baseUrl = process.env.NODE_ENV === "development" ? "http://192.168.0.105:8080/cert" : "http://tools.qidulp.com/cert"
    // baseUrl = process.env.NODE_ENV === "development" ? "http://192.168.0.105:8080/cert" : "http://47.92.28.66:9350/cert"
    return baseUrl
}

// 当前系统图片预览地址
export function imgPreview() {
    let imgHost;
    imgHost = process.env.NODE_ENV === "development" ? "http://47.92.28.66:9301" : "http://cert.qidulp.com";
    // imgHost = process.env.NODE_ENV === "development" ? "http://47.92.28.66:9301" : "http://47.92.28.66:9301";
    return imgHost
}


// api地址
export function APIHost() {
    let path;
    path = process.env.NODE_ENV === "development" ? "http://47.92.28.66:9301/api" : "http://cert.qidulp.com/api";
    // path = process.env.NODE_ENV === "development" ? "http://47.92.28.66:9301/api" : "http://47.92.28.66:9301/api";
    return path;
}

export function paymentHost() {
    let path;
    path = process.env.NODE_ENV === "development" ? "http://192.168.0.105:9353" : "http://order.qidulp.com";
    // path = process.env.NODE_ENV === "development" ? "http://192.168.0.105:8083" : "http://47.92.28.66:9353";
    return path;
}


export function passport() {
    let path;
    // path = process.env.NODE_ENV === "development" ? "http://192.168.0.105:9351/html" : "http://47.92.28.66:9351/html";
    path = process.env.NODE_ENV === "development" ? "http://192.168.0.105:9351/html" : "https://passport.qidulp.com/html";
    return path;
}